import { createFileRoute } from "@tanstack/react-router";
import CustomerNotifications from "@/pages/customer/CustomerNotifications";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/my-account/notifications")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/my-account/notifications' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: CustomerNotifications,
});
